import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export interface TextFieldClasses {
	/** styles applied to the root element */
	root: string;
	fullWidth: string;
}

export function getTextFieldUtilityClass(slot: string) {
	return generateUtilityClass('TextField', slot);
}

export const textFieldClasses = generateUtilityClasses<keyof TextFieldClasses>(
	'TextField',
	['root', 'fullWidth'],
);
export default textFieldClasses;
